import React from 'react'
import { Modal } from 'react-bootstrap'
import AddProject from './AddProject';

const UpdateModal = ({show, handleClose, project, onUpdateProject}) => {

    const handleUpdateProject = (updatedProject) => {
        onUpdateProject(updatedProject);
        handleClose();
    }
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <AddProject
                onSubmit={handleUpdateProject}
                project={project}
            />
        </Modal.Body>
      </Modal>
  )
}

export default UpdateModal